import React, { Component } from 'react';
import { List, Tabs, WhiteSpace, Toast, DatePicker } from 'antd-mobile';
import F2 from '@antv/f2';
import df from 'dateformat';
import { ROOT_PATH } from '../../config';
import axios from 'axios';
import { FARM_ORG, ORG_CODE, TOKEN } from '../../cache';
import qs from 'qs';
import Table from '../../components/Table';
import EmptyReport from '../../components/EmptyReport';

const today = new Date();
let clientWidth = document.documentElement.clientWidth;
let canvasHeight = 365;
let already = 0;

const tabs = [{ title: 'PSY' }, { title: 'MSY' }];

class Psy extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modalShow: false,
      modalHeader: '',
      modalContent: null,
      date: today,
      hasPsyData: true,
      hasMsyData: true,
      data_psy: [],
      data_msy: [],
      columns_psy: [
        { id: 'date', title: '时间', fixed: true, width: 70, align: 'left' },
        { id: 'val1', title: '生产母猪平均存栏', align: 'right' },
        { id: 'val2', title: '期初存栏', align: 'right' },
        { id: 'val3', title: '断奶仔猪数', align: 'right' },
        { id: 'val4', title: '销售断奶仔猪数', align: 'right' },
        { id: 'val5', title: '断奶仔猪转移数', align: 'right' },
        { id: 'val6', title: '期末库存数', align: 'right' }
      ],
      columns_msy: [
        { id: 'date', title: '时间', fixed: true, width: 70, align: 'left' },
        { id: 'val1', title: '生产母猪平均存栏', align: 'right' },
        { id: 'val2', title: '期初存栏', align: 'right' },
        { id: 'val3', title: '销售仔猪', align: 'right' },
        { id: 'val4', title: '销售小猪', align: 'right' },
        { id: 'val5', title: '销售肥猪', align: 'right' },
        { id: 'val6', title: '销售种猪', align: 'right' },
        { id: 'val7', title: '转移后备猪', align: 'right' },
        { id: 'val8', title: '期末存栏', align: 'right' }
      ]
    };
  }

  // 获取 PSY
  getPsyData = (startDate) => {
    axios
      .post(
        `${ROOT_PATH}/api/forward/ifarm/psyGraphCompare`,
        qs.stringify({
          startDate: startDate,
          endDate: startDate,
          dateToday: startDate,
          gd_type: 'D000901',
          gd_code: '1001'
        }),
        {
          headers: {
            'x-http-appid': '1',
            'x-http-device': '0',
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization: TOKEN,
            farmorg: FARM_ORG,
            orgcode: ORG_CODE
          }
        }
      )
      .then((res) => {
        already++;
        let data = this.parseData(res.data);
        this.parsePsyData(data);
      })
      .catch((err) => {
        return err;
      });
  };

  getPsyTableData(startDate) {
    axios
      .post(
        `${ROOT_PATH}/api/forward/ifarm/psyGraph`,
        qs.stringify({
          startDate: startDate,
          endDate: startDate,
          dateToday: startDate,
          gd_type: 'D000901',
          gd_code: '1002'
        }),
        {
          headers: {
            'x-http-appid': '1',
            'x-http-device': '0',
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization: TOKEN,
            farmorg: FARM_ORG,
            orgcode: ORG_CODE
          }
        }
      )
      .then((res) => {
        already++;
        this.updatePsyTable(res.data);
      })
      .catch((err) => {
        return err;
      });
  }

  updatePsyTable(data) {
    let dataSource = [];
    data.map((obj) => {
      let newObj = {};
      let val = obj.month;
      let values = val.split('-');
      values.splice(2, 1);
      val = values.join('.');
      newObj['date'] = val;
      newObj['val1'] = obj.val1 !== undefined ? obj.val1 : '-';
      newObj['val2'] = obj.val2 !== undefined ? obj.val2 : '-';
      newObj['val3'] = obj.val3 !== undefined ? obj.val3 : '-';
      newObj['val4'] = obj.val4 !== undefined ? obj.val4 : '-';
      newObj['val5'] = obj.val5 !== undefined ? obj.val5 : '-';
      newObj['val6'] = obj.val6 !== undefined ? obj.val6 : '-';
      dataSource.push(newObj);
    });
    this.setState({ data_psy: dataSource });
  }

  // 获取 MSY
  getMsyData = (startDate) => {
    axios
      .post(
        `${ROOT_PATH}/api/forward/ifarm/psyGraphCompare`,
        qs.stringify({
          startDate: startDate,
          endDate: startDate,
          dateToday: startDate,
          gd_type: 'D000901',
          gd_code: '2001'
        }),
        {
          headers: {
            'x-http-appid': '1',
            'x-http-device': '0',
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization: TOKEN,
            farmorg: FARM_ORG,
            orgcode: ORG_CODE
          }
        }
      )
      .then((res) => {
        already++;
        let data = this.parseData(res.data);
        this.parseMsyData(data);
      })
      .catch((err) => {
        return err;
      });
  };

  getMsyTableData(startDate) {
    axios
      .post(
        `${ROOT_PATH}/api/forward/ifarm/psyGraph`,
        qs.stringify({
          startDate: startDate,
          endDate: startDate,
          dateToday: startDate,
          gd_type: 'D000901',
          gd_code: '2002'
        }),
        {
          headers: {
            'x-http-appid': '1',
            'x-http-device': '0',
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization: TOKEN,
            farmorg: FARM_ORG,
            orgcode: ORG_CODE
          }
        }
      )
      .then((res) => {
        already++;
        this.updateMsyTable(res.data);
      })
      .catch((err) => {
        return err;
      });
  }

  updateMsyTable(data) {
    let dataSource = [];
    data.map((obj) => {
      let newObj = {};
      let val = obj.month;
      let values = val.split('-');
      values.splice(2, 1);
      val = values.join('.');
      newObj['date'] = val;
      newObj['val1'] = obj.val1 !== undefined ? obj.val1 : '-';
      newObj['val2'] = obj.val2 !== undefined ? obj.val2 : '-';
      newObj['val3'] = obj.val3 !== undefined ? obj.val3 : '-';
      newObj['val4'] = obj.val4 !== undefined ? obj.val4 : '-';
      newObj['val5'] = obj.val5 !== undefined ? obj.val5 : '-';
      newObj['val6'] = obj.val6 !== undefined ? obj.val6 : '-';
      newObj['val7'] = obj.val7 !== undefined ? obj.val7 : '-';
      newObj['val8'] = obj.val8 !== undefined ? obj.val8 : '-';
      dataSource.push(newObj);
    });

    this.setState({ data_msy: dataSource });
  }

  // 解析数据
  parseData(data) {
    if (!data || data.length === 0) {
      return data;
    }

    let barData = data.bar;
    let lineData = data.line;
    barData.map((obj) => {
      let date = obj.period;
      let lineArray = lineData.filter((obj) => {
        return obj.period === date;
      });
      if (lineArray.length) {
        obj['line'] = lineArray[0].val;
      }
    });

    return barData;
  }

  // 绘制报表-- PSY
  parsePsyData(data) {
    if (!data || data.length === 0) {
      this.setState({ hasPsyData: false });
      return;
    }
    this.setState({ hasPsyData: true });

    this.drawPsyReport(data);
  }

  drawPsyReport = (data) => {
    let chart = this.psyChart;
    if (chart) {
      chart.clear();
    } else {
      chart = new F2.Chart({
        id: 'mountNode1',
        pixelRatio: window.devicePixelRatio,
        padding: [70, 'auto', 'auto', 'auto']
      });
    }

    this.psyChart = chart;

    this.drawReport(chart, data, true);
  };

  // 绘制报表-- MSY
  parseMsyData(data) {
    if (!data || data.length === 0) {
      this.setState({ hasMsyData: false });
      return;
    }
    this.setState({ hasMsyData: true });

    this.drawMsyReport(data);
  }

  drawMsyReport = (data) => {
    let chart = this.msyChart;
    if (chart) {
      chart.clear();
    } else {
      chart = new F2.Chart({
        id: 'mountNode2',
        pixelRatio: window.devicePixelRatio,
        padding: [70, 'auto', 'auto', 'auto']
      });
    }

    this.msyChart = chart;

    this.drawReport(chart, data, false);
  };

  drawReport(chart, data, isPsy) {
    let values = [];
    let lines = [];

    data.map((obj) => {
      values.push(obj.val);
      lines.push(obj.line);
    });

    let valueMax = Math.max.apply(null, values);
    let lineMax = Math.max.apply(null, lines);

    let valueObj = { alias: isPsy ? '断奶猪仔' : '出栏肥猪数' };
    if (!valueMax) {
      valueObj['ticks'] = [0, 200, 400, 600, 800, 1000];
    } else {
      valueObj['tickCount'] = 6;
      valueObj['min'] = 0;
    }

    let lineObj = { alias: isPsy ? 'PSY' : 'MSY' };
    if (!lineMax) {
      lineObj['ticks'] = [0, 5, 10, 15, 20, 25];
    } else {
      lineObj['tickCount'] = 6;
      lineObj['min'] = 0;
    }

    const defs = {
      val: valueObj,
      line: lineObj,
      period: {
        formatter: function formatter(val) {
          let values = val.split('-');
          values.splice(2, 1);
          val = values.join('\n');
          return val;
        }
      }
    };
    chart.source(data, defs);

    // 设置坐标轴
    chart.axis('line', {
      // psy / msy
      position: 'left',
      grid: F2.Global._defaultAxis.grid
    });

    chart.axis('val', {
      // 断奶猪仔 / 出栏肥猪数
      position: 'right',
      grid: null
    });

    // 设置图例
    var legendItems = [
      {
        name: isPsy ? 'PSY' : 'MSY',
        fill: '#FE5578',
        marker: function marker(x, y, r, ctx) {
          ctx.lineWidth = 1;
          ctx.strokeStyle = ctx.fillStyle;
          ctx.moveTo(x - 3 - r - 5, y);
          ctx.lineTo(x - 3 + r + 5, y);
          ctx.stroke();
          ctx.arc(x - 3, y, 5, 0, Math.PI * 2, false);
          ctx.fill();
        }
      },
      {
        name: isPsy ? '断奶猪仔' : '出栏肥猪数',
        marker: {
          symbol: 'circle',
          radius: 5,
          fill: '#1890FF'
        }
      }
    ];

    chart.legend({
      position: 'top',
      align: 'center',
      itemWidth: null,
      itemGap: 35,
      wordSpace: 8,
      custom: true,
      items: legendItems,
      titleStyle: {
        fontSize: 14,
        fill: '#666'
      },
      onClick: function(ev) {
        var item = ev.clickedItem;
        var name = item.get('name');
        var checked = item.get('checked');
        var children = item.get('children');
        if (checked) {
          var markerFill = children[0].attr('fill');
          var textFill = children[1].attr('fill');
          children[0].set('_originColor', markerFill); // 缓存 marker 原来的颜色
          children[1].set('_originColor', textFill); // 缓存文本原来的颜色
        }
        var geoms = chart.get('geoms');
        for (var i = 0; i < geoms.length; i++) {
          var geom = geoms[i];
          if (geom.getYScale().alias === name)
            if (!checked) {
              geom.show();
              children[0].attr('fill', children[0].get('_originColor'));
              children[1].attr('fill', children[1].get('_originColor'));
            } else {
              geom.hide();
              children[0].attr('fill', '#bfbfbf'); // marker 置灰
              children[1].attr('fill', '#bfbfbf'); // 文本置灰 置灰
            }
          item.set('checked', !checked);
        }
      }
    });

    // 设置tooltip
    chart.tooltip({
      showCrosshairs: false,
      showItemMarker: true,
      crosshairsType: 'rect',
      tooltipMarkerStyle: {
        type: 'rect'
      },
      background: {
        radius: 6,
        padding: [6, 10]
      },
      onShow: function onShow(ev) {
        ev.tooltipMarkerCfg.type = 'rect';
      }
    });

    // 设置辅助文本
    chart.guide().text({
      position: ['0%', '0%'],
      content: (isPsy ? 'PSY' : 'MSY') + '（头）',
      style: {
        textAlign: 'center',
        fontSize: 9,
        fill: '#666'
      },
      offsetY: -20
    });

    chart.guide().text({
      position: ['100%', '0%'],
      content: (isPsy ? '断奶猪仔' : '出栏肥猪数') + '（头）',
      style: {
        textAlign: 'center',
        fontSize: 9,
        fill: '#666'
      },
      offsetY: -20
    });

    chart
      .interval()
      .position('period*val')
      .color('#1890FF');
    chart
      .line()
      .position('period*line')
      .shape('smooth')
      .color('#FE5578');
    chart
      .point()
      .position('period*line')
      .color('#FE5578')
      .style({
        fill: '#fff',
        lineWidth: 1
      });

    chart.render();
  }

  doSearch = (date) => {
    already = 0;
    Toast.loading('加载中...', 0);

    let y1 = date.getFullYear();
    let m1 = date.getMonth();
    let firstDay = new Date(y1, m1, 1);
    let startDate = df(firstDay, 'yyyy-mm-dd');

    this.getPsyData(startDate);
    this.getPsyTableData(startDate);

    this.getMsyData(startDate);
    this.getMsyTableData(startDate);
  };

  componentDidMount() {
    window._czc.push(['_trackEvent', '进入PSY、MSY页面']);
    this.doSearch(today);
  }

  componentDidUpdate() {
    if (already === 4) {
      Toast.hide();
    }
  }

  componentWillUnmount() {
    this.setState = () => {
      return;
    };
  }

  render() {
    return (
      <React.Fragment>
        <DatePicker
          extra="Optional"
          mode="month"
          onChange={(date) => {
            this.setState({ date });
            this.doSearch(date);
          }}
          title="日期"
          value={this.state.date}
          format={(date) => {
            return `${df(date, 'yyyy-mm')}`;
          }}
        >
          <List.Item arrow="horizontal">选择日期</List.Item>
        </DatePicker>
        <List renderHeader={() => ''}>
          <Tabs tabs={tabs} initialPage={0} animated={false} useOnPan={false} swipeable={false}>
            <div>
              <span className="title">PSY</span>
              {this.state.hasPsyData ? (
                <canvas id="mountNode1" height={canvasHeight} width={clientWidth} />
              ) : (
                <EmptyReport height={canvasHeight} width={clientWidth} />
              )}
              <Table columns={this.state.columns_psy} data={this.state.data_psy} />
            </div>
            <div>
              <span className="title">MSY</span>
              {this.state.hasMsyData ? (
                <canvas id="mountNode2" height={canvasHeight} width={clientWidth} />
              ) : (
                <EmptyReport height={canvasHeight} width={clientWidth} />
              )}
              <Table columns={this.state.columns_msy} data={this.state.data_msy} />
            </div>
          </Tabs>
        </List>
        <WhiteSpace size="xl" />
      </React.Fragment>
    );
  }
}

export default Psy;
